import ApiService from '@/services/core/api.service'

const DealerService = {
  async get (query) {
    return ApiService.get(`marketing-officer/dealers?${query}`)
  },

  async post (payload) {
    return ApiService.post('marketing-officer/dealers', payload)
  },

  async put (payload) {
    return ApiService.put(`marketing-officer/dealers/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`marketing-officer/dealers/${payload.id}`)
  }
}

export default DealerService
